import ArrowDown from "@/assets/icons/arrow_down.svg?react";
import useCustomTranslation from "@/localization/useCustomTranslation";
import { IUser } from "@/types/user.type";
import { cn } from "@fido/ui-lib";
import { useState } from "react";
import { NavLink, useLocation } from "react-router";
import { SidebarRoute } from "../sidebarRoutes";
import { LuArrowDown, LuChevronDown } from "react-icons/lu";

type SidebarItemProps = {
  className?: string;
  item: SidebarRoute;
  profile: IUser;
};
export const SidebarItem = (props: SidebarItemProps) => {
  const { prefixedT } = useCustomTranslation("SIDEBAR");
  const location = useLocation();
  const { Icon } = props.item;

  const [isOpen, setIsOpen] = useState(false);
  const isActive =
    props.item.path &&
    (location.pathname.includes(props.item.path) ||
      `${location.pathname}${location.search}`.includes(props.item.path));

  const hasChildren = props.item.children && props.item.children.length > 0;
  const hasAccess =
    props.item.permissions.includes("*") ||
    props.item.permissions.includes(props.profile?.role?.role_code || "*");

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  if (!hasAccess) {
    return null;
  }

  const Comp = props.item.path ? NavLink : "div";

  return (
    <>
      <Comp
        to={props.item.path}
        data-testid={`parent-${props.item.id}`}
        key={props.item.id}
        className={cn(
          "h-10 pl-7 pr-5 font-medium text-xs no-underline text-[#F9F9F9] whitespace-nowrap flex items-center justify-start gap-3 transition-colors duration-300 cursor-pointer",
          isActive
            ? "text-[#00558C] bg-white"
            : "hover:text-[#00558C] hover:bg-white",
          props.className
        )}
        onClick={hasChildren ? toggleDropdown : undefined}
      >
        {Icon && <Icon className="h-5 w-5 shrink-0" />}
        <span className="truncate">{prefixedT(props.item.translation)}</span>
        {hasChildren && (
          <LuChevronDown
            className={cn(
              "transition-transform duration-300 h-5 w-5 shrink-0",
              isOpen ? "scale-y-[-1]" : "scale-y-[1]"
            )}
          />
        )}
      </Comp>

      {isOpen &&
        hasChildren &&
        props.item.children.map((childRoute) => (
          <SidebarItem
            key={childRoute.id}
            item={childRoute}
            profile={props.profile}
            className="pl-9"
          />
        ))}
    </>
  );
};
